import { createFileRoute } from "@tanstack/react-router";
import { PageHero } from "@/components/PageHero";
import { ServiceCard } from "@/components/ServiceCard";
import { CTASection } from "@/components/CTASection";
import { SectionHeading } from "@/components/SectionHeading";
import { SERVICES } from "@/lib/site";
import { buildBreadcrumbs } from "@/components/SchemaJsonLd";
import heroImg from "@/assets/hero-garage.jpg";
import serviceHeroImg from "@/assets/service-hero.jpg";
import flakeImg from "@/assets/service-flake.jpg";
import metallicImg from "@/assets/service-metallic-v3.jpg";
import commercialImg from "@/assets/service-commercial.jpg";
import grindingImg from "@/assets/service-grinding-v3.jpg";
import resurfacingImg from "@/assets/service-grinding-new.jpg";

const IMG: Record<string, string> = {
  "flake-epoxy-flooring": flakeImg,
  "metallic-epoxy-flooring": metallicImg,
  "solid-color-epoxy-flooring": commercialImg,
  "polyaspartic-floor-coatings": serviceHeroImg,
  "grind-and-seal-concrete": grindingImg,
  "concrete-resurfacing": resurfacingImg,
};

export const Route = createFileRoute("/services/")({
  head: () => ({
    meta: [
      { title: "Floor Coating Services Calgary | MLC Epoxy Floors" },
      { name: "description", content: "Epoxy, polyaspartic, metallic, flake, and grind-and-seal floor coatings for homes and businesses across the Calgary region." },
      { property: "og:title", content: "Floor Coating Services | MLC Epoxy Floors" },
      { property: "og:description", content: "Premium epoxy, polyaspartic, metallic, and grind-and-seal floor coatings for the Calgary region." },
      { property: "og:url", content: "/services" },
    ],
    links: [{ rel: "canonical", href: "/services" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(buildBreadcrumbs([
        { name: "Home", href: "/" }, { name: "Services", href: "/services" }
      ])) },
    ],
  }),
  component: ServicesHub,
});

function ServicesHub() {
  return (
    <>
      <PageHero
        eyebrow="Premium Coating Systems"
        title="Floor Coating Services for the Calgary region"
        body="Every MLC Epoxy Floors system is diamond-ground, professionally installed by our own W-2 crews, and finished with a UV-stable polyaspartic topcoat. Browse our systems below."
        image={heroImg}
      />
      <section className="section-light section-ivory border-y border-border py-20 md:py-24">
        <div className="container-x">
          <SectionHeading eyebrow="Our Systems" title="Six Coating & Repair Systems. One Standard Of Quality." />
          <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {SERVICES.map((s) => (
              <ServiceCard key={s.slug} slug={s.slug} name={s.name} short={s.short} benefits={s.benefits} image={IMG[s.slug]} />
            ))}
          </div>
        </div>
      </section>
      <CTASection />
    </>
  );
}
